export default __webpack_public_path__ + "static/media/spinner.78c71b66.svg";